import { Component, ReactNode } from "react";
import { logPile } from "../logPile";

// Catches a render/lifecycle error anywhere under it, reports it to log-pile
// with React's component stack (which the window error handler can't see),
// and offers a reload instead of a blank page.
type Props = { children: ReactNode };
type State = { error?: Error };

export class ErrorBoundary extends Component<Props, State> {
  state: State = {};

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: { componentStack?: string | null }) {
    logPile.captureException(error, {
      level: "fatal",
      tags: { where: "render" },
      extra: { componentStack: info.componentStack ?? undefined },
    });
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="min-h-screen flex items-center justify-center p-6 text-center">
        <div className="space-y-3">
          <h1 className="text-lg font-semibold">Something went wrong</h1>
          <p className="text-sm text-neutral-500">It's been reported. Reloading usually fixes it.</p>
          <button className="bg-neutral-900 text-white rounded px-3 py-2 dark:bg-neutral-100 dark:text-neutral-900" onClick={() => window.location.reload()}>
            Reload
          </button>
        </div>
      </div>
    );
  }
}
